import { createPage } from './helpers/create-page'

// ============================================
// PUBLIC ROUTES
// ============================================

export const CbUnicoSuccessPage = createPage(() => import('@pages/static/cb-unico-success-page'))

export const FirstAccessPage = createPage(
  () => import('@pages/static/first-access/first-access-page')
)

export const FirstAccessCpfPage = createPage(
  () => import('@pages/static/first-access/cpf/first-access-cpf-page')
)

export const SkillExplorerCatalogPage = createPage(
  () => import('@pages/skill-explorer-catalog/skill-explorer-catalog')
)

export const LoginPage = createPage(() => import('@pages/auth/login'))

export const ForgotPasswordPage = createPage(() => import('@pages/auth/forgot-password'))

export const ResetPasswordPage = createPage(() => import('@pages/auth/reset-password'))

export const LoginFirstAccessPage = createPage(
  () => import('@/presentation/pages/auth/login-first-access')
)

// ============================================
// CONTENT DISCOVERY
// ============================================

export const HomePage = createPage(() => import('@pages/home/home-page'))

export const SearchPage = createPage(() => import('@pages/search/search-page'))

export const FavoritesPage = createPage(() => import('@pages/favorites/favorites-page'))

export const CategorySearchPage = createPage(() => import('@pages/search/category-search-page'))

export const CategoryGroupSearchPage = createPage(
  () => import('@pages/search/category-group-search-page')
)

export const SkillSearchPage = createPage(() => import('@pages/search/skill-search-page'))

export const InstitutionSearchPartnerPage = createPage(
  () => import('@pages/search/institution-search-page')
)

export const InstitutionsListPartnersPage = createPage(
  () => import('@pages/search/institutions-search-page')
)

export const ContentPage = createPage(() => import('@pages/content/content-details/content-page'))

export const ContentEnrollmentPage = createPage(
  () => import('@pages/content/content-enrollment/content-enrollment-page')
)

export const ContentCompletePage = createPage(
  () => import('@pages/content/content-complete/content-complete-page')
)

export const ContentUnsubscribePage = createPage(
  () => import('@pages/content/content-unsubscribe/content-unsubscribe-page')
)

// ============================================
// CB ÚNICO
// ============================================

export const CbUnicoStartPage = createPage(() => import('@pages/cbu/cb-unico-start-page'))

// ============================================
// PROFILE ASSESSMENT
// ============================================

export const ProfileAssessmentGetStartedPage = createPage(
  () => import('@pages/profile-assessment/get-started-page')
)

export const ProfileAssessmentCallbackPage = createPage(
  () => import('@pages/profile-assessment/profile-assessment-callback-page')
)

export const ProfileAssessmentInProgressPage = createPage(
  () => import('@pages/profile-assessment/profile-assessment-in-progress-page')
)

// ============================================
// USER DATA & PROFILE
// ============================================

export const UserProfilePage = createPage(() => import('@pages/user-profile/user-profile-page'))

export const UserInterestAreasSkillsPage = createPage(
  () => import('@pages/user-interest-areas-skills/user-interest-areas-skills-page')
)

export const UserSettingsPage = createPage(() => import('@pages/user-settings/user-settings-page'))

export const UserSpacePage = createPage(() => import('@pages/user-space/user-space-page'))

export const UserEnrollmentsPage = createPage(
  () => import('@pages/user-enrollments/user-enrollments-page')
)

export const UserEnrollmentDetailPage = createPage(
  () => import('@pages/user-enrollment-detail/user-enrollment-detail-page')
)

export const ContactVerificationPage = createPage(
  () => import('@pages/contact-verification/contact-verification-page')
)

// ============================================
// ONBOARDING
// ============================================

export const OnboardingWelcomePage = createPage(
  () => import('@pages/onboarding/onboarding-welcome-page')
)

export const OnboardingLayout = createPage(
  () => import('@presentation/components/ui/layout/onboarding-layout')
)

export const OnboardingPersonalDataPage = createPage(
  () => import('@pages/onboarding/onboarding-personal-data-page')
)

export const OnboardingProfessionalTrajectoryPage = createPage(
  () => import('@pages/onboarding/onboarding-professional-trajectory-page')
)

export const Onboarding2Page = createPage(() => import('@pages/onboarding/onboarding-2-page'))

export const Onboarding3Page = createPage(() => import('@pages/onboarding/onboarding-3-page'))

export const Onboarding4Page = createPage(() => import('@pages/onboarding/onboarding-4-page'))

export const OnboardingSecurityPage = createPage(
  () => import('@pages/onboarding/onboarding-security-page')
)

export const OnboardingCompletedPage = createPage(
  () => import('@pages/onboarding/onboarding-completed-page')
)

// ============================================
// DEPENDENT REQUEST
// ============================================

export const DependentRequestPage = createPage(
  () => import('@pages/dependent-request/dependent-request-page')
)

export const DependentRequestCatalogPage = createPage(
  () => import('@pages/dependent-request/dependent-request-catalog-page')
)

export const DependentContentPage = createPage(
  () => import('@pages/content/content-details/dependent-content-page')
)

// ============================================
// UPGRADE REQUEST
// ============================================

export const UpgradeRequestPage = createPage(
  () => import('@pages/upgrade-request/upgrade-request-page')
)

// ============================================
// REFUND
// ============================================

export const RefundProgramListPage = createPage(
  () => import('@pages/refund/refund-program-list-page')
)

export const RefundRequestPage = createPage(
  () => import('@pages/refund/request/refund-request-page')
)

// ============================================
// COMPANY MANAGER
// ============================================

export const DashboardPage = createPage(
  () => import('@pages/company-manager/dashboard/dashboard-page')
)

export const CreateUserProfilePage = createPage(
  () => import('@pages/company-manager/create-user-profile/create-user-profile-page')
)

export const EditUserProfilePage = createPage(
  () => import('@pages/company-manager/edit-user-profile/edit-user-profile-page')
)

export const DependentHolderSearchPage = createPage(
  () => import('@pages/company-manager/dependent/holder-search/holder-search-page')
)

export const DependentRegistrationPage = createPage(
  () =>
    import('@pages/company-manager/dependent/dependent-registration/dependent-registration-page')
)

export const DependentSearchPage = createPage(
  () => import('@pages/company-manager/dependent/dependent-search/dependent-search-page')
)

export const RequestsConfigurationPage = createPage(
  () => import('@pages/company-manager/requests/requests-configuration/requests-configuration-page')
)

export const DependentEnrollmentPage = createPage(
  () => import('@pages/company-manager/dependent/dependent-enrollment/dependent-enrollment-page')
)

export const UpgradeEnrollmentPage = createPage(
  () => import('@pages/company-manager/upgrade/upgrade-enrollment/upgrade-enrollment-page')
)

// ============================================
// INTERNAL COMPANY MANAGER
// ============================================

export const BatchDisableUserPage = createPage(
  () => import('@pages/internal-company-manager/batch-disable-user/batch-disable-user-page')
)

export const InvoicePage = createPage(
  () => import('@pages/internal-company-manager/invoice/invoice-event-list-page')
)

export const InvoiceDetailPage = createPage(
  () => import('@pages/internal-company-manager/invoice/invoice-event-detail-page')
)

export const CompanyDetailPage = createPage(
  () => import('@pages/internal-company-manager/company/company-detail-page')
)

export const PartnerDetailPage = createPage(
  () => import('@pages/internal-company-manager/partner/partner-detail-page')
)
